"use client";

import WaitlistInset from "./WaitlistInset";

// Single waitlist inset: Maren on the phone. The NCLEX card was removed
// 2026-07-01 (founder direction + landing audit): advertising a second
// exam vertical on a young MCAT product reads as unfocused to the exact
// audience we need to trust us, and the founder is not building it until
// MCAT is done. The /waitlist backend still accepts the nclex product
// key, so the list and any future page survive; only the homepage
// surface is gone. Subtle section; does not compete with Start Free.
export default function ComingSoonSection() {
  return (
    <section className="py-20 sm:py-24 bg-white dark:bg-maren-charcoal border-t border-maren-sage/30 dark:border-maren-sage/20">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-maren-green dark:text-maren-gold">
            On the way
          </p>
          <h2 className="mt-4 font-display font-medium tracking-tight text-3xl sm:text-4xl leading-[1.15] text-maren-charcoal dark:text-maren-stone">
            What is coming next.
          </h2>
        </div>

        <div className="max-w-xl mx-auto">
          <WaitlistInset
            inputId="waitlist-mobile"
            title="Maren on your phone."
            description="The mobile app is in development. Log a question between classes, review weak areas on the go, study in the moments you used to lose."
            product="mobile_app"
            buttonLabel="Join the list"
          />
        </div>
      </div>
    </section>
  );
}
